import * as React from 'react';
import View from 'components/View';
import BecomePartnerForm from '../BecomePartnerForm';
import Heading from 'components/text/Heading';
import { useTranslation } from 'next-i18next';
import Paragraph from 'components/text/Paragraph';

import PoinzContactDetails from 'components/PoinzContactDetails';

const BecomePartnerFormSection: React.FC = () => {
  const { t } = useTranslation();
  return (
    <View
      id="supportForm"
      className="ContactUsFormSection flex gap-12 md:gap-16 flex-col md:flex-row py-24 md:py-32"
    >
      <div className="md:w-1/2">
        {/* heading LG */}
        <Heading className="hidden lg:block" variant="h2">
          {t('becomePartner.formSectionTitle')}
        </Heading>
        {/* heading SM */}
        <Heading className="block lg:hidden" variant="h2">
          {t('becomePartner.formSectionTitle')}
        </Heading>
        <Paragraph className="mt-2 md:mt-4">
          {t('becomePartner.formSectionDescriptionFirstParagraph')}
        </Paragraph>
        <Paragraph className="mt-2 md:mt-4">
          {t('becomePartner.formSectionDescriptionSecondParagraph')}
        </Paragraph>

        <PoinzContactDetails />
      </div>
      <BecomePartnerForm />
    </View>
  );
};

export default BecomePartnerFormSection;
